import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  background: #fff;
  .ant-table {
    height: 74vh !important;
    overflow: hidden;
  }
  .ant-table-wrapper {
    border: 1px solid #e8e8e8;
    margin-top: 15px;
    margin-bottom: 15px;
    width: 95%;
    height: 100%;
    border-radius: 10px;
  }
  .ant-table-thead > tr:first-child > th:first-child {
    border-top-left-radius: 10px;
  }
  .ant-table-thead > tr:first-child > th:last-child {
    border-top-right-radius: 10px;
  }
  .ant-table-fixed-header > .ant-table-content > .ant-table-scroll > .ant-table-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .ant-table-thead > tr > th .ant-table-header-column {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .ant-table-row-cell-ellipsis .ant-table-column-title {
    overflow: initial;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 16px 16px;
    font-size: 14px;
    p {
      font-size: 14px;
    }
  }
  .ant-checkbox + span {
    font-size: 14px;
  }
  .ant-table-thead > tr > th .ant-table-filter-selected.anticon {
    color: #000 !important;
  }
  .ant-table-placeholder {
    border-bottom: 1px solid transparent;
  }
  .ant-table-column-sorter-inner .ant-table-column-sorter-up.on,
  .ant-table-column-sorter-down.on {
    color: #000 !important;
  }
  .ant-spin-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  ////////////   table-pagination /////////
  .ant-table-pagination.ant-pagination {
    position: fixed;
    bottom: 30px;
    margin: 2px 0;
  }
  .ant-pagination-item a {
    text-decoration: none;
    transition: none;
  }
  .ant-pagination-item:focus a,
  .ant-pagination-item:hover a {
    color: #000;
  }
  .ant-pagination-item:focus,
  .ant-pagination-item:hover {
    border-color: #000;
  }
  .ant-pagination-item-active,
  .ant-pagination-item-active:hover,
  .ant-pagination-item-active:focus {
    font-weight: 500;
    background: #000;
    border-color: #000;
  }
  .ant-pagination-item-active a,
  .ant-pagination-item-active:focus a,
  .ant-pagination-item-active:hover a {
    color: #fff;
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: #000;
    border-color: #000;
  }
  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled,
  .ant-pagination-disabled:hover,
  .ant-pagination-disabled:focus {
    color: rgba(0, 0, 0, 0.25) !important;
    border-color: #d9d9d9 !important;
    cursor: not-allowed;
  }
  .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
  .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
    color: #000;
  }
  .ant-table-tbody > tr > td {
    .templateId {
      color: #000;
      font-weight: 600;
      text-decoration: none;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .ant-calendar-range-picker-input {
    display: none;
  }
  .ant-calendar-range-picker-separator {
    display: none;
  }
  .ant-calendar-picker-clear {
    right: 0;
  }
  .ant-calendar-picker-icon {
    right: 15px;
  }
  .ant-calendar-picker .ant-calendar-picker-input:not(.ant-input-disabled) {
    border: none;
    background-color: transparent;
  }
  .ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled),
  .ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled) {
    border-color: transparent !important;
    box-shadow: none !important;
    .anticon-calendar {
      color: #000;
      cursor: pointer;
    }
  }
  .ant-calendar-range-right .ant-calendar-date-input-wrap {
    margin-left: 100px !important;
  }
  .ant-spin-dot-item {
    background-color: rgb(177, 39, 44);
  }
  .ant-badge-status-dot {
    width: 8px;
    height: 8px;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  // height: 600px;
  height: 100%;
  width: 1250px;
  .buttonDiv {
    .ant-btn-primary {
      margin: 20px;
      margin-top: 0;
      margin-bottom: 0;
      color: #fff;
      background-color: #000;
      border-color: #000;
      border-radius: 15px;
      text-transform: uppercase;
      font-size: 12px;
    }
  }
  .title {
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 10px;
  }
`;
export const TimeLineDiv = styled.div`
  height: 450px;
  margin: 15px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  .ant-timeline {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .ant-timeline-item-tail {
    border-left: 2px dotted #cbcaca;
  }
  .ant-timeline-item {
    width: 425px;
  }
  .anticon.anticon-check-circle {
    font-size: 15px;
    color: #37c337;
  }
  .anticon.anticon-mail {
    color: #000;
  }
  .anticon-close-circle {
    font-size: 15px;
    color: #df4141;
  }
  .anticon.anticon-loading {
    color: #df4141;
  }
  .status {
    font-weight: 700;
    font-size: 14px;
    color: #898787;
  }
  .currentStep.status {
    transform: scale(1.1);
    font-weight: 700;
    color: #000;
    margin: 10px;
    margin-top: 0;
    margin-bottom: 0;
  }
`;
export const AddressContainer = styled.div`
  width: 700px;
  // box-shadow: 0 1rem 3rem rgb(0 0 0 / 18%) !important;
  // box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
  padding: 25px;
  height: 100%;
  overflow-y: auto;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  .mail {
    display: flex;
    flex-direction: row;
    border-bottom: 2px solid #cecece;
    align-items: center;
    padding-bottom: 6px;
  }
  h3 {
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-left: 5px;
  }
  p {
    font-size: 14px;
    margin-top: 6px;
    margin-bottom: 30px;
    .add {
      margin: 0;
    }
  }
`;
